import { gql } from '@apollo/client';

export const createSmtpSetup = gql`mutation createSmtpSetup($id: Int, $smtpName: String, $smtpHost: String, $smtpPort: String, $smtpEmail: String, $smtpSender: String, $smtpSenderEmail: String, $smtpPassword: String) {
    createSmtpSetup(id: $id, smtpName: $smtpName, smtpHost: $smtpHost, smtpPort: $smtpPort, smtpEmail: $smtpEmail, smtpSender: $smtpSender, smtpSenderEmail: $smtpSenderEmail, smtpPassword: $smtpPassword) {
      status
      errorMessage
    }
  }  
`;

export const deleteSmtpSetup = gql`mutation deleteSmtpSetup($id: Int!) {
    deleteSmtpSetup(id: $id) {
      status
      errorMessage
    }
  }  
`;

export const getAllSmtpData = gql`query getAllSmtpData($currentPage: Int, $searchList: String) {
    getAllSmtpData(currentPage: $currentPage, searchList: $searchList) {
      count
      results {
        id
        smtpName
        smtpHost
        smtpPort
        smtpEmail
        smtpSender
        smtpPassword
        smtpSenderEmail
        isActive
        isEnable
      }
      status
      errorMessage
    }
  }
`;

export const updateSmtpActiveStatus = gql`mutation updateSmtpActiveStatus($id: Int!) {
    updateSmtpActiveStatus(id: $id) {
      status
      errorMessage
    }
  }  
`;